import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IProposalState } from './proposal.state';

export class ProposalSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly proposalState = (state: IRootState): IProposalState => {
    return state.proposal as IProposalState;
  };

  static readonly model = createSelector(ProposalSelectors.proposalState, (proposal: IProposalState) => {
    return proposal.model;
  });

  static readonly data = createSelector(ProposalSelectors.proposalState, (proposal: IProposalState) => {
    return proposal.data;
  });
}
